<ng-container (window:resize)="onWindowResize()">
  <ion-grid class="grid">
    <ion-row class="row">
      <ion-col class="col codere-sidebar-pc" *ngIf="isDesktop">
        <codere-sidebar-pc
          [sports]="sidebarFacade.sports"
          [highlights]="sidebarFacade.highlights"
          [highlightsConfig]="sidebarFacade.highlightsConfig"
          [selectedSport]="sidebarFacade.selectedSport"
        ></codere-sidebar-pc>
      </ion-col>

      <ion-col class="col">
        <div #pageToRender></div>
      </ion-col>

      <ion-col class="col aside" *ngIf="isDesktop">
        <div
          id="video-player-ticket"
          class="background-color-dark"
          [class.streaming-desktop-slot]="globalVars?.videoPlayerWindow"
        ></div>
        <sportradar-widget
          *ngIf="sportService?.showSportradar$ | async"
          [statisticsId]="sportService?.eventStatisticsId$ | async"
          [isFormula1]="sportService?.isFormula1$ | async"
          [SPO_LMTFormula1]="globalVars?.FEATURES.SPO_LMTFormula1"
        ></sportradar-widget>

        <sb-tabs
          [categories]="betslipFilters"
          [color]="'dark'"
          [selectedTab]="selectedBetslipFilter"
          (selectTab)="changeTicketType($event.index)"
        ></sb-tabs>

        <my-bets-betslip [selectedFilter]="selectedBetslipFilter" *ngIf="!showTicket"> </my-bets-betslip>

        <ticket
          *ngIf="showTicket"
          [ticketState]="ticket$ | async"
          (ticketOddAcceptance)="newTicketFacade?.presentOddAcceptance()"
          [class.streaming-desktop-slot]="globalVars?.videoPlayerWindow"
        >
        </ticket>
      </ion-col>
      
    </ion-row>
  </ion-grid>
  <ticket-mobile *ngIf="isMobile && !isDesktop" ></ticket-mobile>
</ng-container>
